import React, { useState, useEffect } from 'react';
import MediaCard from './MediaCard';
import SearchFilter from './SearchFilter';

// Mock data for local development
const MOCK_DATA = {
  pregnancy: [
    { id: '1', date: '2024-01-15', description: 'First ultrasound - saw the heartbeat!', mediaUrl: 'https://drive.google.com/uc?id=PLACEHOLDER1&export=view', mediaType: 'image' },
    { id: '2', date: '2024-02-20', description: 'Baby bump starting to show', mediaUrl: 'https://drive.google.com/uc?id=PLACEHOLDER2&export=view', mediaType: 'image' },
    { id: '3', date: '2024-03-10', description: 'Baby shower celebration', mediaUrl: 'https://drive.google.com/uc?id=PLACEHOLDER3&export=view', mediaType: 'image' },
  ],
  growth: [
    { id: '4', date: '2024-06-01', description: 'First day at home - so tiny!', mediaUrl: 'https://drive.google.com/uc?id=PLACEHOLDER4&export=view', mediaType: 'image' },
    { id: '5', date: '2024-07-15', description: 'First smile captured!', mediaUrl: 'https://drive.google.com/uc?id=PLACEHOLDER5&export=view', mediaType: 'image' },
    { id: '6', date: '2024-09-01', description: 'Started rolling over', mediaUrl: 'https://drive.google.com/uc?id=PLACEHOLDER6&export=view', mediaType: 'image' },
  ]
};

function TimelineView({ journey, refresh, startDate, endDate }) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchDate, setSearchDate] = useState('');
  const [filteredEntries, setFilteredEntries] = useState([]);

  useEffect(() => {
    fetchEntries();
  }, [journey, refresh, startDate, endDate]);

  useEffect(() => {
    filterEntries();
  }, [entries, searchDate]);

  const fetchEntries = async () => {
    try {
      setLoading(true);
      // Check if running in local mode
      if (process.env.REACT_APP_LOCAL_MODE === 'true') {
        // Use mock data
        const mockEntries = MOCK_DATA[journey] || [];
        const sorted = mockEntries.sort((a, b) => new Date(b.date) - new Date(a.date));
        setEntries(sorted);
      } else {
        // Fetch from API Gateway
        const apiUrl = process.env.REACT_APP_API_GATEWAY_URL;
        console.log('API URL:', apiUrl, 'Journey:', journey);
        const response = await fetch(`${apiUrl}/entries?journey=${journey}`);
        console.log('Fetch response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('API response:', data);
        
        // Sort by date descending (newest first)
        const sorted = data.entries.sort((a, b) => new Date(b.date) - new Date(a.date));
        setEntries(sorted);
      }
    } catch (error) {
      console.error('Error fetching entries:', error);
      setEntries([]);
    } finally {
      setLoading(false);
    }
  };

  const filterEntries = () => {
    let filtered = entries;

    if (startDate) {
      filtered = filtered.filter(entry => new Date(entry.date) >= new Date(startDate));
    }

    if (endDate) {
      filtered = filtered.filter(entry => new Date(entry.date) <= new Date(endDate));
    }

    setFilteredEntries(filtered);
  };

  if (loading) {
    return <div className="text-center py-12">Loading entries...</div>;
  }

  return (
    <div>
      <SearchFilter searchDate={searchDate} onSearchChange={setSearchDate} viewType="timeline" />

      {filteredEntries.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg">
          <p className="text-gray-500 text-lg">No entries found</p>
        </div>
      ) : (
        <div className="space-y-6">
          {filteredEntries.map((entry) => (
            <MediaCard key={entry.id} entry={entry} viewType="timeline" />
          ))}
        </div>
      )}
    </div>
  );
}

export default TimelineView;

